import React from "react";

export const SignUpFormChanged = React.createContext(null);
